import React from 'react'
import "./BestsellingProducts.css";
import carpetsCImage from "../assets/images/bgcta.png";
import { Link } from "react-router-dom"; //Link

export default function BgCta() {
  return (
    <div className="bgcta_main" style={{ backgroundImage: `url(${carpetsCImage})` }}>
      <div className="container">
        <div className="bgcta_item" >
        <h3>Refresh Your Home This Season</h3>
        <h4>Designed for Luxury.</h4>
        <Link to="/sale">Browse Collection </Link>
      </div>
      </div>
    </div>
  )
}
